<template>
  <div>
    <v-app-bar
      class="desktop_main"
      style="background-color: #fff"
      :class="{ desktop_main: windowWidth > 576 }"
      v-if="
        (showAppBar && $vuetify.breakpoint.xsOnly) || $vuetify.breakpoint.smOnly
      "
      clipped-left
      clipped-right
      flat
      app
    >
      <img
        src="../assets/ui/menu.svg"
        style="font-size: 24px"
        v-if="state.profile.isSigned"
        @click.stop="close_sidebar = !close_sidebar"
        alt=""
      />

      <span
        v-if="headerName && view_form == ''"
        class="col justify-content-center header-text text-center pr-10"
        >{{ headerName }}
      </span>
      <span
        v-if="headerName && view_form == true"
        @click="editform()"
        class="col justify-content-center header-text text-center mobileview pr-10"
        >{{ headerName }}
        <img
          class="cursor-pointer"
          src="../assets/ui/edit_icon.svg"
          alt=""
          style="background-color: transparent;padding-left:4px"
        />
      </span>
      <img
        v-if="delete_form != undefined"
        class="icon_color cursor-pointer mobileview"
        src="../assets/ui/delete_icon.svg"
        alt=""
        @click="deleteform()"
        style="background: transparent"
      />
    </v-app-bar>

    <!-- delete bottom sheet -->
    <v-bottom-sheet v-model="delete_form_value">
      <v-sheet class="text-center bottom_modal" height="200px">
        <div class="pt-8 text_color">{{ $t("newUi.editForm.deleteForm") }}</div>
        <v-container>
          <div>{{ $t("newUi.deleteForm.confirmDelete") }}</div>
          <v-spacer style="padding: 10px"></v-spacer>
          <v-btn
            color="#8AB26D"
            class="button_padding"
            @click="doCancelDelete"
            >{{ $t("common.cancelButton") }}</v-btn
          >
          <v-btn
            color="#8AB26D"
            class="button_padding"
            @click="doDeleteFormMobile(delete_form)"
            >{{ $t("common.deleteButton") }}</v-btn
          >
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- <div class="desktopView_sidebar"> -->
    <v-navigation-drawer
      v-if="showAppBar"
      clipped
      :permanent="!$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly"
      app
      class="sideBar desktop_sidebar_background"
      :width="315"
    >
      <v-list dense nav>
        <v-list-item>
          <img
            src="../assets/logo/LogoGreen.png"
            width="200"
            style="left: -15px; position: absolute;"
            alt="logo"
            class="img-fluid"
          />
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <div class="text-white padding-bottom-10">
                {{ $t("newUi.sideBarData.signedIn") }}
              </div>
              <div class="padding-bottom-10" style="color: #f8faf7;">
                {{ state.profile.name }}
              </div>
              <div class="cursor-pointer mt-2 heading_color" @click="logout">
                {{ $t("newUi.sideBarData.signedOut") }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <router-link
          class="heading_color"
          :to="'/orderManagement'"
          tag="v-list-item-title"
        >
          <v-list-item
            link
            :class="{ hightlight_name: $route.fullPath == '/orderManagement' }"
            @click="handleNotification"
          >
            <span
              v-if="$store.state.isNotificationMsg !== null"
              class="unread"
            ></span>
            <v-list-item-content>
              <span class="heading_color">{{
                $t("newUi.OrderManagement.OMheading")
              }}</span>
            </v-list-item-content>
          </v-list-item>
        </router-link>

        <router-link
          class="heading_color"
          :to="'/admin'"
          tag="v-list-item-title"
        >
          <v-list-item
            link
            :class="{ hightlight_name: $route.fullPath == '/admin' }"
          >
            <v-list-item-content @click="handleNotification"
              ><span class="heading_color">{{
                $t("sideBar.menu.text2")
              }}</span></v-list-item-content
            >
          </v-list-item></router-link
        >

        <v-list-item>
          <span class="heading_color">{{
            $t("newUi.sideBarData.formsTitle")
          }}</span>
        </v-list-item>

        <v-list-item
          v-for="(item, index) in $store.state.forms"
          :key="index"
          link
          @click="routeToViewForm(item.link.split('/')[3])"
          :class="{
            hightlight_name: $route.fullPath.includes(
              `/admin/viewform/${item.link.split('/')[3]}`
            ),
          }"
        >
          <!-- <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>  -->
          <v-list-item-content @click="handleNotification"
            ><v-list-item-title class="list_style">{{
              item.shopname
            }}</v-list-item-title></v-list-item-content
          >
        </v-list-item>
        <v-list-item>
          <span class="heading_color">{{
            $t("sideBar.menu.text3")
          }}</span></v-list-item
        >
        <v-list-item
          link
          @click="createoderform('Ordering form')"
          :class="{
            hightlight_name: $route.fullPath.includes(
              `/admin/editform/${$store.state.currentForm.pos}`
            ),
          }"
        >
          <v-list-item-content @click="handleNotification"
            ><v-list-item-title class="list_style">
              {{ $t("newUi.sideBarData.orderForm") }}
            </v-list-item-title></v-list-item-content
          ></v-list-item
        >
        <v-list-item
          link
          @click="createoderform('Catalogue')"
          :class="{
            hightlight_name: $route.fullPath.includes(
              `/admin/category_form/${$store.state.currentForm.pos}`
            ),
          }"
        >
          <v-list-item-content @click="handleNotification"
            ><v-list-item-title class="list_style">
              {{ $t("newUi.sideBarData.catForm") }}
            </v-list-item-title></v-list-item-content
          ></v-list-item
        >
        <v-list-item link>
          <v-list-item-content class="heading_color">
            <!-- <router-link :to="'/'" tag="v-list-item-title"></router-link> -->
            <span class="heading_color" @click="homepage">
              {{ $t("newUi.sideBarData.gotoBecho") }}
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link style="margin:20px 0px">
          <v-list-item-content
            class="whatsapp_sidebar whatsapp_sidebar-extension"
            ><router-link
              class="heading_color d-flex "
              style="align-items: center ;"
              to="/whatsappwidget"
              tag="v-list-item-title"
            >
              <img
                src="../assets/ui/whatsapp_icon.svg"
                style="font-size: 24px"
                alt=""
              />
              <span class="">
                {{ $t("newUi.sideBarData.widgetButton") }}
              </span></router-link
            ></v-list-item-content
          >
        </v-list-item>
        <v-list-item link style="margin:20px 0px">
          <v-list-item-content
            class="whatsapp_sidebar whatsapp_sidebar-extension"
            style="background:#8AB26D"
          >
            <router-link
              class="heading_color d-flex "
              style="align-items: center;"
              to="/guide"
              tag="v-list-item-title"
            >
              <img
                src="../assets/ui/whatsapp_icon.svg"
                style="font-size: 24px"
                alt=""
              />
              <span class="">
                {{ $t("newUi.pluginGuide.sidebar") }}
              </span>
            </router-link> </v-list-item-content
          ><br />
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- </div>
    <div class="mobile_sidebar"> -->
    <v-navigation-drawer
      v-if="showAppBar"
      clipped
      app
      v-model="close_sidebar"
      class="sideBar mobileview"
      :width="294"
    >
      <v-list dense nav>
        <v-list-item>
          <img
            src="../assets/logo/LogoDark.png"
            width="200"
            style="left: -30px;position: absolute;"
            alt="logo"
            class="img-fluid"
          />
        </v-list-item>

        <v-list-item style="background-color: #f8faf7">
          <v-list-item-content>
            <v-list-item-title>
              <div class="normal signin-text">
                {{ $t("newUi.sideBarData.signedIn") }}
              </div>
              <!-- <v-avatar size="36">
                <v-img :src="state.profile.imageurl"></v-img>
              </v-avatar> -->
              <div class="text_color user-text">{{ state.profile.name }}</div>
              <div class="cursor-pointer mt-3" @click="logout">
                {{ $t("newUi.sideBarData.signedOut") }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="handleNotification">
          <span
            v-if="$store.state.isNotificationMsg !== null"
            class="unread"
          ></span>
          <v-list-item-content
            ><router-link :to="'/orderManagement'" tag="v-list-item-title">{{
              $t("newUi.OrderManagement.OMheading")
            }}</router-link></v-list-item-content
          >
        </v-list-item>
        <v-list-item link>
          <v-list-item-content
            ><router-link :to="'/admin'" tag="v-list-item-title">{{
              $t("sideBar.menu.text2")
            }}</router-link></v-list-item-content
          >
        </v-list-item>

        <v-list-item class="mobileview">
          <span class="text_color">{{
            $t("newUi.sideBarData.formsTitle")
          }}</span>
        </v-list-item>
        <v-list-item
          class="mobileview"
          v-for="(item, index) in $store.state.forms"
          :key="index"
          link
        >
          <!-- <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>  -->
          <v-list-item-content
            ><v-list-item-title
              @click="routeToViewForm(item.link.split('/')[3])"
              class="list_style_mobile"
              >{{ item.shopname }}</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>

        <v-list-item class="mobileview">
          <span class="text_color">{{
            $t("sideBar.menu.text3")
          }}</span></v-list-item
        >
        <v-list-item
          class="mobileview"
          link
          @click="createoderform('Ordering form')"
        >
          <v-list-item-content
            ><v-list-item-title class="list_style_mobile">
              {{ $t("newUi.sideBarData.orderForm") }}
            </v-list-item-title></v-list-item-content
          ></v-list-item
        >
        <v-list-item
          class="mobileview"
          link
          @click="createoderform('Catalogue')"
        >
          <v-list-item-content
            ><v-list-item-title class="list_style_mobile">
              {{ $t("newUi.sideBarData.catForm") }}
            </v-list-item-title></v-list-item-content
          ></v-list-item
        >
        <v-list-item link>
          <v-list-item-content>
            <!-- <router-link :to="'/'" tag="v-list-item-title" class="text_color"></router-link> -->
            <span class="homepage_link" @click="homepage">
              {{ $t("newUi.sideBarData.gotoBecho") }}
            </span></v-list-item-content
          >
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <router-link to="/whatsappwidget" tag="v-list-item-title">
              <i
                class="bi bi-whatsapp"
                style="font-size: 24px; color: green"
              ></i>
              {{ $t("newUi.sideBarData.widgetButton") }}
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <router-link to="/guide" tag="v-list-item-title">
              <i
                class="bi bi-whatsapp"
                style="font-size: 24px; color: #8AB26D"
              ></i>
              {{ $t("newUi.pluginGuide.sidebar") }}
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <br />
      </v-list>
    </v-navigation-drawer>
    <!-- </div> -->
    <v-dialog
      class="desktopView"
      v-model="form_logout_desktop"
      content-class="dialog_logout"
    >
      <v-container class="1">
        <!-- <div class="d-flex justify-space-between text_color"> -->
        <div
          class="d-flex justify-end justify-content-end text_color"
          style="font-size: 20px;"
        >
          <span class="cursor-pointer" @click="closing_logout_desktop">x</span>
        </div>
        <!-- </div> -->
        <v-container class="text-center">
          <div class="col" style="padding-top: 0px;">
            <div>
              <p style="font-weight: bolder;">
                {{ $t("newUi.sideBarData.logOutConfirm") }}
              </p>
              <p style="margin-bottom: 0px !important" v-show="$store.state.logout_count>=2 && !this.$store.state.user.data.email ?true:false">{{$t("alertText.logoutAlert")}}</p>
            </div>
          </div>
          <v-btn
            @click="confirmSignOut"
            class="button_padding"
            color="#128c7e"
            >{{ $t("newUi.sideBarData.signedOut") }}</v-btn
          >
        </v-container>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../router/router";
import { saveFile, deleteFile, deleteMasterData,logoutDataUpload } from "../services/firebase";
import { setLocale } from "../services/firebase";
import store from "../store/store";
import i18n from "../i18n";
import { onMessageListener } from "../services/firebase";

// import i18n from "../i18n";
// import { mapGetters } from "vuex";

export default {
  name: "AdminHeader",
  props: ["headerName", "view_form", "delete_form"],

  mounted() {
    setLocale();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    // Foregroud notification message listner
    onMessageListener()
      .then((payload) => {
        console.log("called");
        this.$store.dispatch("setNotificationMsg", payload.data.body);
      })
      .catch((err) => {
        console.log("err", err);
      });
    // When app goes in background then recive method from onBackground method
    const broadcast = new BroadcastChannel("notification-channel");
    broadcast.onmessage = (event) => {
      if (event.data && event.data.type === "SEND_NOTIFICATION") {
        this.$store.dispatch("setNotificationMsg", event.data.payload);
      }
    };
  },
  data() {
    return {
      delete_form_value: false,
      windowWidth: "",
      close_sidebar: false,
      form_logout_desktop: false,

    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    homepage() {
      // this.$router.go();
      window.location.href = "/";
    },
    logout: function() {
      // this.$store.dispatch("logout");
      this.form_logout_desktop = true;
      // this.$store.dispatch("logout");
    },
    confirmSignOut: function() {
      this.form_logout_desktop = false;
      if(!this.$store.state.user.data.email)
      {
        var logout=this.$store.state.last_logout!=""?new Date(this.$store.state.last_logout):new Date();
        var count=0;
        var current=new Date();
        if(!logout)
        {
          store.dispatch('setLogOutCount',1); 
        }
        else{
            if(logout.getFullYear()<current.getFullYear() || logout.getMonth()<current.getMonth() || logout.getDate()<current.getDate())
            {
              count=1;
              logoutDataUpload(this.$store.state.currentForm.id,current,count);
            }
            else if(logout.getDate()==current.getDate() && logout.getFullYear()==current.getFullYear() && logout.getMonth()==current.getMonth()) 
            {
              count=parseInt(this.$store.state.logout_count)+1
              logoutDataUpload(this.$store.state.currentForm.id,current,count);
            }
          }
      }
      this.$store.dispatch("logout");  
    },
    startLogin: function() {
      this.$store.dispatch("startLogin");
    },
    closing_logout_desktop() {
      this.form_logout_desktop = false;
    },
    createWhatsAppWidget: function() {
      router.push("/whatsappwidget");
    },
    editform: function() {
      router.push("/editform/" + this.$store.state.currentForm.pos);
    },
    deleteform: function() {
      this.delete_form_value = true;
    },
    doDeleteFormMobile: function(link) {
      this.delete_form_value = false;
      this.deleteFormFile(link);
    },
    routeToViewForm: function(pos) {
      this.$store.dispatch("fileLoaded", false);
      router.push("/admin/viewform/" + pos);
    },
    doCancelDelete: function() {
      this.delete_form_value = false;
    },
    deleteFormFile: function(formlink) {
      //controller.pause();
      // debugger
      var storedata = this.$store;
      console.log("storedata", storedata.state);
      this.$store.dispatch("setOverlay", true);
      // console.log("form lenth begin ", this.$store.state.forms.length);

      for (var i = 0; i < this.$store.state.forms.length; i++) {
        if (this.$store.state.forms[i].link.split("/")[3] === formlink) {
          this.$store.state.forms.splice(i, 1);
          deleteMasterData(function(err) {
            console.log(err);
            return 0;
          }, this.$store.state);
          //var pos = parseInt(formlink.split("/")[3]);
          // var pos;
          // if (formlink.split("/")[3]) {
          //   pos = parseInt(formlink.split("/")[3]);
          // } else {
          //   pos = parseInt(formlink.split("/")[2]);
          // }
          deleteFile(this.$store.state.profile.uid, formlink, function() {
            storedata.dispatch("setOverlay", false);
          });
          break;
        }
      }
      router.push("/admin");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    createoderform(type) {
      var createPos = this.getFreePos();
      if (createPos === -1) {
        alert(i18n.t("alertText.fiveForms"));
        return;
      }

      //this.selectType(createPos);
      var newlink =
        type == "Ordering form"
          ? `/admin/editform/${createPos}`
          : `/admin/category_form/${createPos}`;

      var newForm = {
        id: store.state.profile.uid,
        pos: createPos,
        categs: ["Ordering form", "Catalogue"],
        shopname: "",
        shopdesc: "",
        type: type,
        catalogue: [],
        phone: "",
        amount: 0,
        maxlength: 0,
      };

      saveFile(
        store.state.profile.uid,
        createPos,
        JSON.stringify(newForm),
        function() {
          //state.forms.push({"shopname": "", "type": + type, "link":"/admin/" + createPos});
          if (router.currentRoute.fullPath != newlink) {
            router.push(newlink);
          } else {
            router.go();
          }
        }
      );
    },
    getFreePos() {
      var isPresent = [];
      for (var ii = 0; ii < 5; ii++) isPresent[ii] = false;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        var formlink = this.$store.state.forms[i].link;
        var ipos;
        if (formlink.split("/")[3]) {
          ipos = parseInt(formlink.split("/")[3]);
        } else {
          ipos = parseInt(formlink.split("/")[2]);
        }

        if (ipos >= 0 && ipos < 5) isPresent[ipos] = true;
      }
      for (var j = 0; j < 5; j++) if (!isPresent[j]) return j;
      return -1;
    },
    selectType(callback) {
      this.$store.dispatch("setCurCallback", callback);
      //router.push("/newform");
      this.$store.state.newformroute.newformdialog = true;
      // console.log("1");
      this.$store.dispatch("setOverlay", false);
    },
    //  onResize() {
    //   this.windowHeight = window.innerHeight;
    // },
    handleNotification() {
      this.$store.dispatch("setNotificationMsg", null);
    },
  },
  /*
  watch: {
    windowWidth(newWidth, oldWidth) {},
  },*/

  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
    window_width() {
      return window.innerWidth;
    },
    showAppBar() {
      if (this.$route.name === "viewform" || this.$route.name === "base")
        return false;
      return true;
    },
    ordforms(state) {
      var toret = [];
      state = this.$store.state;
      if (state.forms) {
        for (var i = 0; i < state.forms.length; i++) {
          var f = state.forms[i];
          if (f.type === "Ordering form") {
            toret.push(f);
          }
        }
      }
      return toret;
    },
    catforms(state) {
      var toret = [];
      state = this.$store.state;
      if (state.forms) {
        for (var i = 0; i < state.forms.length; i++) {
          var f = state.forms[i];
          if (f.type === "Catalogue") {
            toret.push(f);
          }
        }
      }
      return toret;
    },
  },
};
</script>
<style lang="scss">
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
.desktop_main {
  width: 100%;
  background: #8ab26d;
}
.v-list-item {
  min-height: 5px;
}
.v-divider {
  margin: 5px 0px;
}
div.v-list-item {
  min-height: 10px;
}
v-list-item {
  min-height: 10px;
}
.heading_color {
  color: #ffffff;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  opacity: 1;
}
.dialog_logout {
  width: 350px;
  height: 210px;
  background-color: #f8faf7;
}
.viewform_header_buttons {
  background-color: #666666;
  color: #f8faf7;
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 12px;
  margin: 2px;
  border-radius: 3px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;
}
.hightlight_name {
  background-color: #707070;
}
.list_style {
  color: #f8faf7 !important;
  padding-left: 30px !important;
}
.desktop_sidebar_background {
  background: #31333e !important;
}
.whatsapp_sidebar .v-list-item__title {
  padding: 0 20px;
}
.whatsapp_sidebar .v-list-item__title span {
  width: 100%;
  text-align: center;
}
.whatsapp_sidebar.whatsapp_sidebar-extension span {
  max-width: 100px;
  white-space: normal;
  margin: 0 auto;
}
.whatsapp_sidebar {
  border-radius: 100px !important;
}
.whatsapp_sidebar .v-list-item__title {
  min-height: 30px;
}
@media (min-width: 960px) {
  .whatsapp_sidebar {
    background-color: #128c7e;
    color: white;
    border-radius: 20px;
  }
  .v-dialog__content .dialogcss,
  .v-dialog {
    margin: 5px;
  }
  .mobileview {
    display: none;
  }
  .bkg-main {
    width: 100%;
    background: #8ab26d;
  }
  .mobile_sidebar {
    display: none;
    visibility: hidden;
  }
  .padding-bottom-10 {
    padding-bottom: 10px;
  }
  .logo_white {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .logo_green {
    text-align: left;
    font-size: 24px;
    font-style: italic;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
  }
}
@media (max-width: 960px) {
  .list_style_mobile {
    padding-left: 30px !important;
  }
  .form_title {
    color: #8ab26d;
    font-size: 18px;
  }
  .desktopView {
    display: none;
  }
  .header-text {
    text-align: center;
    font-size: 16px;
    letter-spacing: 0px;
    font-weight: bold;
    color: #666666;
    opacity: 1;
  }
  .homepage_link {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
  }
  .user-text {
    color: #8ab26d;
    font-weight: bold;
  }
  .signin-text {
    font-size: 12px;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1;
  }
  .icon_color {
    color: #8ab26d;
    justify-content: center;
    font-size: 20px;
    width: 26px;
    height: 26px;
    background-color: #f8faf7;
    padding: 5px;
    margin: 3px;
    border-radius: 3px;
  }

  .text_color {
    color: #8ab26d !important;
    font-weight: bold;
  }
  .desktopView_sidebar {
    display: none;
    visibility: hidden;
  }
  .logo_white {
    text-align: left;
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
  }
  .logo_green {
    text-align: left;
    font-size: 22px;
    font-style: italic;
    font-weight: bold;
    letter-spacing: 0px;
    color: #8ab26d;
  }
}
nav.sideBar span.unread {
  position: initial;
  margin: 0px 8px 0 0px;
  width: 8px;
  height: 8px;
}
.unread {
  background: #e9505b;
  width: 7px;
  position: absolute;
  height: 7px;
  border-radius: 50%;
  margin: 6px -55px;
}
.desktop_sidebar_background .v-list {
  padding: 8px 0;
}

.desktop_sidebar_background .v-list .v-list-item {
  border-radius: 0;
  padding: 0 10px;
}
.desktop_sidebar_background .v-list .v-list-item.hightlight_name {
  background: rgb(255 255 255 / 10%);
}
//sidebar
// nav.sideBar {
//   width: 300px !important;
// }
</style>
